import _ from 'lodash';
import {
  getPricingEshopProductMargins,
  updatePricingEshopProductMargins,
} from '../../../../api/pricing/pricingMargins';
import { PricingEshopProductMargins } from '../../../../api/pricing/pricingMarginsTypes';
import { Edit } from './pricingMarginsState';

function formatMargin(value?: number): string {
  return _.isNil(value) ? '' : String(value);
}

function parseMargin(value: string): number | undefined {
  const trimmed = value.trim();

  return trimmed ? Number(trimmed) : undefined;
}

function mapEdit(margins: PricingEshopProductMargins): Edit {
  return {
    partnerDemandedMinimumMarginAbs: formatMargin(margins.partnerDemandedMinimumMarginAbs),
    partnerRelativeDemandedMinimumMargin:
      formatMargin(margins.partnerRelativeDemandedMinimumMargin),
    partnerRegularMarginAbs: formatMargin(margins.partnerRegularMarginAbs),
    partnerRelativeRegularMargin: formatMargin(margins.partnerRelativeRegularMargin),
  };
}

function mapRequest(
  marketplaceCode: string,
  partnerProductCode: string,
  edit: Edit,
): PricingEshopProductMargins {
  return {
    marketplaceCode,
    partnerProductCode,
    partnerDemandedMinimumMarginAbs: parseMargin(edit.partnerDemandedMinimumMarginAbs),
    partnerRelativeDemandedMinimumMargin: parseMargin(edit.partnerRelativeDemandedMinimumMargin),
    partnerRegularMarginAbs: parseMargin(edit.partnerRegularMarginAbs),
    partnerRelativeRegularMargin: parseMargin(edit.partnerRelativeRegularMargin),
  };
}

export async function loadMargins(
  marketplaceCode: string,
  partnerProductCode: string,
  signal?: AbortSignal,
): Promise<Edit> {
  const margins = await getPricingEshopProductMargins(marketplaceCode, partnerProductCode, signal);

  return mapEdit(margins);
}

export async function saveMargins(
  marketplaceCode: string,
  partnerProductCode: string,
  edit: Edit,
  signal?: AbortSignal,
): Promise<void> {
  await updatePricingEshopProductMargins(
    mapRequest(marketplaceCode, partnerProductCode, edit),
    signal,
  );
}
